module.exports = __webpack_public_path__ + "static/media/profile3.9270272a.jpg";